const TOKEN_KEY = 'access_token';

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
  getAccessToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  hasAccessToken() {
    return this.getAccessToken() !== null;
  },

  setAccessToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  removeAccessToken() {
    localStorage.removeItem(TOKEN_KEY)
  },
};

export default TokenService;




// WEBPACK FOOTER //
// ./src/services/token.service.js